import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { isValidEmail, isValidNsn, toNsn } from "../utils/phoneHelper";

export default function useSchema() {
  const { t } = useTranslation("Common");

  const userSalesSchema = yup
    .object()
    .shape({
      userId: yup.string().required(t("schema.required.id")),
      todayDate: yup.string().required(t("schema.required.today"))
    })
    .required();

  const voucherSchema = yup
    .object()
    .shape({
      voucherCode: yup.string().required(t("schema.required.voucher"))
    })
    .required();

  const giftcardSchema = yup
    .object()
    .shape({
      giftcardCode: yup.string().required(t("schema.required.giftcard")),
      amount: yup.string().required(t("schema.required.amount"))
    })
    .required();

  // Takes the selected country because the field beside the selector holds the
  // national number alone. Moved here from utils/schemas.js, where its messages
  // were hardcoded English.
  const buildRegisterMemberSchema = (countryCode) =>
    yup
      .object()
      .shape({
        phoneNumber: yup
          .string()
          .trim()
          .required(t("schema.required.phone"))
          .test("valid-phone", t("schema.invalid.phone"), (value) =>
            isValidNsn(toNsn(value, countryCode), countryCode)
          ),
        email: yup
          .string()
          .trim()
          .required(t("schema.required.email"))
          .test("valid-email", t("schema.invalid.email"), (value) =>
            isValidEmail(value)
          ),
        firstName: yup.string().required(t("schema.required.firstName")),
        lastName: yup.string().required(t("schema.required.lastName")),
        // Stored as the full selected plan object; require at least an id/name.
        plan: yup
          .object()
          .shape({
            id: yup.mixed().required(),
            name: yup.string().required(),
          })
          .nullable()
          .required(t("schema.required.plan")),
      })
      .required();

  return {
    userSalesSchema,
    voucherSchema,
    giftcardSchema,
    buildRegisterMemberSchema
  };
}
